/*
 * ExitGameScreen
 * ==========
 */

import StatsScreen from '../ui/StatsScreen'

export default class ExitGameScreen extends StatsScreen {

    constructor(game, screens) {
        super(game, 'exitGame');
        this.screens = screens;
        this.params = {
            'title': [0, -50],
            'subtitle': [1, -4],
            'yes': [-51, 57],
            'no': [50, 57]
        };

        this.bg = this.addSprite('bg', 'uiScreens', 'uiExitPanel.png');
        this.title = this.addText2('title', 'blue', 'Exit game', 28);
        this.subtitle = this.addText2('subtitle', 'blue', 'Are you sure?', 18);
        this.yes = this.addTextButton2('yes', 'uiYesButton', 'Yes', this.yesClicked);
        this.no = this.addTextButton2('no', 'uiNoButton', 'No', this.noClicked);
        this.setInputForAllButtons(false)
    }

    yesClicked(that) {
        that.forceOutForAllButtons();
        that.screens.showScreen('gameStart');
        that.clicked = 'yes';

        _gameGATracker('send', 'event', 'Quit Game', GS.level, GS.score);

        ARK_game_arena_connector.fireEventToArena('event_change');
        ARK_game_arena_connector.changeScore(GS.score, 'Quit Game');
        ARK_game_arena_connector.fireEventToArena('game_end');
    }

    noClicked(that) {
        that.forceOutForAllButtons();
        that.screens.hideScreen();
        that.clicked = 'no';

        ARK_game_arena_connector.fireEventToArena('event_change');
    }

    onHideEnded() {
        super.onHideEnded();
        if (this.clicked === 'no') {
            GS.resume()
        } else {
            GS.setupLevel(1)
        }
    }
}
